module.exports = __webpack_public_path__ + "static/media/instagram.087377dd.svg";